<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="1200px"
      class="analysisTemplateDialog"
    >
      <!-- <div v-if="showDialog == true" class="a-dialog" v-el-drag-dialog> -->
      <div class="a-d-top">
        <div class="a-d-topTit"><div style="width: 136px">分析模板</div></div>
        <div>
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="text"
            clearable
            :disabled="tagBox != 0"
          >
          </el-input>
        </div>
        <div class="a-d-t-right">
          <span @click.stop="close()">×</span>
        </div>
      </div>
      <div style="display: flex; height: 100%">
        <div class="a-d-t-left">
          <div
            class="a-d-t-l-item"
            :style="
              tagIndex == 0
                ? 'background: rgba(226, 238, 255, 1);color: rgba(54, 129, 252, 1)'
                : ''
            "
            @click="changeTagIndex(0)"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              :fill="tagIndex == 0 ? 'rgba(54, 129, 252, 1)' : ''"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.24631 3.31889C4.39003 3.48483 4.5 3.71135 4.5 4C4.5 4.21383 4.43908 4.42076 4.37585 4.58868C4.31084 4.76131 4.22691 4.93402 4.15339 5.08241C4.14191 5.10557 4.13074 5.12806 4.11987 5.14991C4.0675 5.25528 4.02236 5.34609 3.98528 5.429C4.09021 5.45929 4.22201 5.49097 4.38342 5.52931L4.38901 5.53064C4.613 5.58384 4.8813 5.64757 5.12663 5.73276C5.36448 5.81535 5.64621 5.9391 5.85355 6.14645C6.11009 6.40298 6.33398 6.62549 6.55 6.7875C6.57557 6.80668 6.60008 6.82426 6.62356 6.84036C6.60065 6.62896 6.56135 6.37394 6.51745 6.08906C6.5136 6.06411 6.50972 6.03893 6.50581 6.01353C6.44409 5.61232 6.3769 5.16333 6.35987 4.78001C6.35135 4.58845 6.35407 4.39119 6.38366 4.21235C6.4111 4.04645 6.4734 3.81949 6.64645 3.64645C6.79022 3.50268 6.96736 3.4206 7.15797 3.40105C7.33565 3.38282 7.49722 3.4215 7.624 3.4676C7.85363 3.55111 8.08452 3.70525 8.25398 3.81838C8.26191 3.82367 8.2697 3.82887 8.27735 3.83397C8.47166 3.96351 8.60184 4.04699 8.70314 4.08705C8.88791 3.88492 9.08437 3.58823 9.24029 3.27639C9.42017 2.91663 9.5 2.62864 9.5 2.5C9.5 2.3908 9.50831 2.28917 9.52388 2.1951C9.03768 2.06784 8.52706 2 8 2C6.57918 2 5.2743 2.49337 4.24631 3.31889ZM10.4992 2.54355C10.4868 2.90704 10.3223 3.34849 10.1347 3.72361C9.9317 4.12964 9.65302 4.55409 9.35355 4.85355C9.20978 4.99732 9.03264 5.0794 8.84203 5.09895C8.66435 5.11718 8.50278 5.0785 8.376 5.0324C8.14637 4.94889 7.91548 4.79475 7.74602 4.68162C7.73809 4.67633 7.7303 4.67113 7.72265 4.66603C7.5675 4.56259 7.45324 4.48853 7.36191 4.44248C7.35509 4.51776 7.35353 4.6151 7.35888 4.73561C7.3731 5.05542 7.43091 5.45018 7.49419 5.86147C7.49902 5.89288 7.5039 5.92447 7.5088 5.95618C7.56519 6.32126 7.62397 6.70183 7.6399 6.99645C7.64819 7.14993 7.64892 7.33381 7.6071 7.4954C7.5859 7.57731 7.54296 7.69777 7.4454 7.80414C7.33265 7.92708 7.1746 8 7 8C6.58685 8 6.22872 7.79654 5.95 7.5875C5.67135 7.37851 5.40027 7.10741 5.16018 6.86729L5.14645 6.85355C5.10379 6.8109 4.99936 6.74715 4.7986 6.67743C4.60736 6.61102 4.38703 6.55799 4.15231 6.50224C4.14335 6.50011 4.13433 6.49797 4.12525 6.49582C3.91462 6.44583 3.67461 6.38888 3.4872 6.31672C3.39021 6.27937 3.26738 6.22356 3.16133 6.13585C3.04981 6.04362 2.91073 5.87448 2.91073 5.6262C2.91073 5.42474 2.98419 5.22766 3.04214 5.09033C3.09599 4.96271 3.16483 4.82442 3.22693 4.69963C3.23729 4.67882 3.24746 4.65839 3.25734 4.63844C3.33114 4.48951 3.39453 4.35701 3.44001 4.23625C3.47551 4.14198 3.49153 4.07642 3.4973 4.03431C2.56495 5.09197 2 6.47961 2 8C2 11.3137 4.68629 14 8 14C8.60402 14 9.18645 13.9109 9.73529 13.7454C9.69605 13.3855 9.48271 12.6898 8.64645 11.8536C7.86209 11.0692 7.43312 10.3101 7.48212 9.53112C7.53095 8.75466 8.0445 8.13799 8.68257 7.61369C8.90237 7.43307 9.14863 7.32441 9.41568 7.30078C9.67738 7.27761 9.91965 7.33952 10.1314 7.43409C10.5352 7.61443 10.914 7.95564 11.2376 8.26185C11.3117 8.33198 11.3839 8.40128 11.4547 8.46928C11.7178 8.7218 11.9621 8.95635 12.2155 9.14849C12.5374 9.39262 12.7899 9.5 13 9.5C13.2934 9.5 13.5061 9.65809 13.6372 9.80807C13.6587 9.83265 13.6791 9.85809 13.6983 9.88416C13.8941 9.29191 14 8.6586 14 8C14 5.57889 12.5658 3.49165 10.4992 2.54355ZM13.1093 11.1473C13.0836 10.988 13.041 10.8035 12.9819 10.6516C12.9536 10.5788 12.9273 10.5288 12.9071 10.4974C12.406 10.469 11.9679 10.2158 11.6112 9.94526C11.3066 9.71424 11.0071 9.42639 10.7397 9.16942C10.6745 9.10673 10.6112 9.04589 10.5502 8.98815C10.2133 8.66936 9.94951 8.44807 9.72358 8.34716C9.62045 8.3011 9.5511 8.2927 9.50384 8.29688C9.46193 8.30059 9.40187 8.31693 9.31743 8.38631C8.73851 8.86201 8.50207 9.24534 8.48014 9.59388C8.45838 9.93987 8.63791 10.4308 9.35355 11.1464C10.1671 11.96 10.5527 12.7476 10.6863 13.3666C11.685 12.8657 12.525 12.0938 13.1093 11.1473ZM3.05771 3.04281C4.32332 1.78097 6.07094 1 8 1C8.83754 1 9.64178 1.14731 10.3875 1.41786C13.0772 2.39368 15 4.97166 15 8C15 9.27618 14.658 10.474 14.0604 11.5052C13.2419 12.9176 11.9438 14.0175 10.3875 14.5821C9.64178 14.8527 8.83754 15 8 15C4.13401 15 1 11.866 1 8C1 6.06334 1.78713 4.30959 3.05771 3.04281Z"
                fill-opacity="0.9"
              />
            </svg>
            <span>社区</span>
          </div>

          <div
            class="a-d-t-l-item"
            :style="
              tagIndex == 1
                ? 'background: rgba(226, 238, 255, 1);color: rgba(54, 129, 252, 1)'
                : ''
            "
            @click="changeTagIndex(1)"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              :fill="tagIndex == 1 ? 'rgba(54, 129, 252, 1)' : ''"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                fill-opacity="0.9"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 3.5C6.34315 3.5 5 4.84315 5 6.5C5 7.4718 5.46207 8.33567 6.17849 8.88391C4.87325 9.46238 3.89454 10.6435 3.59534 12.0742C3.86963 12.3706 4.17347 12.6393 4.50218 12.8755C4.56774 11.0002 6.10868 9.5 8.00001 9.5C9.89133 9.5 11.4323 11.0002 11.4978 12.8755C11.8265 12.6393 12.1304 12.3706 12.4047 12.0742C12.1055 10.6435 11.1268 9.46238 9.82152 8.88391C10.5379 8.33567 11 7.4718 11 6.5C11 4.84315 9.65685 3.5 8 3.5ZM6 6.5C6 5.39543 6.89543 4.5 8 4.5C9.10457 4.5 10 5.39543 10 6.5C10 7.60457 9.10457 8.5 8 8.5C6.89543 8.5 6 7.60457 6 6.5Z"
                fill-opacity="0.9"
              />
            </svg>

            <span>我的</span>
          </div>

          <div
            class="a-d-t-l-item"
            :style="
              tagIndex == 2
                ? 'background: rgba(226, 238, 255, 1);color: rgba(54, 129, 252, 1)'
                : ''
            "
            @click="changeTagIndex(2)"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              :fill="tagIndex == 2 ? 'rgba(54, 129, 252, 1)' : ''"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.00001 1.5C8.1894 1.5 8.36253 1.61128 8.44723 1.78745L10.3276 5.69853L14.062 6.18401C14.2515 6.20865 14.411 6.34338 14.4729 6.53124C14.5349 6.71909 14.4886 6.92726 14.3536 7.06769L11.5537 9.9795L12.4851 13.8539C12.5302 14.0413 12.4715 14.2393 12.3329 14.368C12.1942 14.4967 11.9984 14.5347 11.8245 14.4669L8.00001 12.9754L4.17558 14.4669C4.0016 14.5347 3.80578 14.4967 3.66714 14.368C3.52849 14.2393 3.46988 14.0413 3.51494 13.8539L4.44628 9.9795L1.64646 7.06769C1.51143 6.92726 1.4651 6.71909 1.52708 6.53124C1.58905 6.34338 1.7485 6.20865 1.938 6.18401L5.67247 5.69853L7.5528 1.78745C7.6375 1.61128 7.81063 1.5 8.00001 1.5ZM8.00001 3.18275L6.44723 6.41255C6.37246 6.56806 6.22792 6.67442 6.06203 6.69598L3.07646 7.08411L5.35357 9.4523C5.47776 9.58146 5.52768 9.76891 5.48509 9.94611L4.71603 13.1454L7.82445 11.9331C7.93764 11.889 8.06238 11.889 8.17558 11.9331L11.284 13.1454L10.5149 9.94611C10.4723 9.76891 10.5223 9.58146 10.6465 9.4523L12.9236 7.08411L9.938 6.69598C9.77211 6.67442 9.62756 6.56806 9.5528 6.41255L8.00001 3.18275Z"
                fill-opacity="0.9"
              />
            </svg>

            <span>收藏</span>
          </div>
        </div>
        <div class="a-d-box" v-loading="loading">
          <div class="boxList" v-show="tagBox == 0">
            <div
              style="
								font-family: PingFang SC;
								font-size: 16px;
								font-weight: 600;
								line-height: 22px;
								text-align: left;
								margin: 0px 0 10px 0;
							"
            >
              {{ dialogTagList[tagIndex] }}
            </div>
            <div class="a-d-b-subject">
              <span
                :class="[
                  'a_d_b_s_btn',
                  tagSubject == item.value ? 'a_d_b_s_ActiveBtn' : ''
                ]"
                v-for="(item, index) in tagSubjectList"
                :key="index + '-' + tagIndex"
                @click.stop="changeTagSubject(item.value)"
                >{{ item.label }}</span
              >
            </div>
            <div style="display: flex; flex-wrap: wrap">
              <div
                class="a-d-b-item"
                v-for="(item, index) in templateData"
                :key="index"
              >
                <div class="a-d-b-i-top">
                  <img
                    style="height: 22px; width: 22px"
                    :src="
                      require('../../../../assets/icon/classroomObservation/digImg.svg')
                    "
                  />
                  <div class="a-d-b-i-t-title">
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="a_d_b_i_t_collect" @click.stop="collect(item)">
                    <img
                      v-if="
                        collectData.filter(i => i.id == item.id).length == 0
                      "
                      :src="
                        require('../../../../assets/icon/classroomObservation/collect1.svg')
                      "
                    />
                    <img
                      v-else
                      :src="
                        require('../../../../assets/icon/classroomObservation/collect2.svg')
                      "
                    />
                  </div>
                </div>
                <div class="a-d-b-i-bottom">{{ item.detail }}</div>
                <div class="a-d-b-i-bottomPer">
                  <span>{{ item.use }}人已使用</span>
                  <span>{{
                    tagSubjectList.find(i => i.value == item.type)
                      ? tagSubjectList.find(i => i.value == item.type).label
                      : ""
                  }}</span>
                </div>
                <div class="a-d-b-i-bottomBtn">
                  <div class="btnBox">
                    <div
                      style="background-color: #f0f2f5; color: black"
                      @click="editAnalysis(item)"
                      v-if="userId == item.userid"
                      class="bb_edit"
                    >
                      编辑
                    </div>
                    <div
                      style="border: solid 1px #3681fc; color: #3681fc"
                      class="bb_preview"
                      @click="previewAnalysis(item)"
                    >
                      预览
                    </div>
                    <div
                      class="bb_use"
                      style="background-color: #3681fc; color: white"
                      @click="useAnalysis(item)"
                    >
                      使用
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="analysisDetail"
            v-if="analysisDetail != null"
            v-show="tagBox == 1 || tagBox == 2"
          >
            <div class="ad_header">
              <div class="ad_h_top">
                <div class="ad_h_t_left">
                  <span class="ad_h_t_back" @click="back()">
                    <img
                      :src="
                        require('../../../../assets/icon/classroomObservation/right.svg')
                      "
                    />
                    返回
                  </span>
                  <div class="ad_h_t_l_title">{{ analysisDetail.name }}</div>
                  <span
                    @click.stop="collect(analysisDetail)"
                    class="ad_h_t_l_collect"
                  >
                    <img
                      v-if="
                        collectData.filter(i => i.id == analysisDetail.id)
                          .length == 0
                      "
                      :src="
                        require('../../../../assets/icon/classroomObservation/collect1.svg')
                      "
                    />
                    <img
                      v-else
                      :src="
                        require('../../../../assets/icon/classroomObservation/collect2.svg')
                      "
                    />
                  </span>
                </div>
                <div class="ad_h_t_right">
                  <el-button
                    v-if="tagBox == 1"
                    type="primary"
                    @click.stop="saveTemplate(analysisDetail)"
                    >完成</el-button
                  >
                  <el-button
                    v-if="tagBox == 2"
                    type="primary"
                    @click.stop="useAnalysis(analysisDetail)"
                    >使用</el-button
                  >
                  <el-button
                    v-if="
                      tagBox == 2 &&
                        (!defaultData || defaultData.id != analysisDetail.id)
                    "
                    type="primary"
                    @click.stop="setDefault(analysisDetail)"
                    >设为默认</el-button
                  >
                  <el-button
                    v-if="
                      tagBox == 2 &&
                        defaultData &&
                        defaultData.id == analysisDetail.id
                    "
                    type="info"
                    :disabled="true"
                    >已设为默认</el-button
                  >
                </div>
              </div>
              <div class="ad_h_bottom">
                <span>{{
                  tagSubjectList.find(i => i.value == analysisDetail.type)
                    ? tagSubjectList.find(i => i.value == analysisDetail.type)
                        .label
                    : ""
                }}</span>
                <span class="ad_h_b_shu"></span>
                <span>{{ analysisDetail.detail }}</span>
              </div>
            </div>
            <div class="ad_bottom">
							<analysis
                :ref="`analysis${item.value}`"
								:key="item.value"
								v-for="item in dialogTagList2"
                @delItem="delAnalysisItem"
                :title="item.name"
                @addAnalysisItem="addAnalysisItem"
                :showAdd="tagBox == 1"
                :analysisItemList="
                  analysisDetail.tips.filter(i => i.Type === item.value)
                "
                :type="item.value"
              />
              <!-- <analysis
                ref="analysis0"
                @delItem="delAnalysisItem"
                title="通用课堂分析"
                @addAnalysisItem="addAnalysisItem"
                :showAdd="tagBox == 1"
                :analysisItemList="
                  analysisDetail.tips.filter(i => i.Type === 0)
                "
                :type="0"
              />
              <analysis
                ref="analysis1"
                @delItem="delAnalysisItem"
                title="学科课堂分析"
                @addAnalysisItem="addAnalysisItem"
                :showAdd="tagBox == 1"
                :analysisItemList="
                  analysisDetail.tips.filter(i => i.Type === 1)
                "
                :type="1"
              />
              <analysis
                ref="analysis2"
                @delItem="delAnalysisItem"
                title="扩展分析"
                @addAnalysisItem="addAnalysisItem"
                :showAdd="tagBox == 1"
                :analysisItemList="
                  analysisDetail.tips.filter(i => i.Type === 2)
                "
                :type="2"
              /> -->
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <addNewAnalysisDialog
      :dialogTagDataList="dataList"
      ref="addNewAnalysisDialogRef"
      @success="addNewAnalysisItem"
    />
  </div>
</template>

<script>
import analysis from "./analysis2.vue";
import addNewAnalysisDialog from "./addNewAnalysisDialog.vue";
export default {
  components: {
    analysis,
    addNewAnalysisDialog
  },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      userId: this.$route.query["userid"],
      text: "",
      loading: false,
      tagSubject: "",
      tagIndex: 0,
      tagBox: 0, //0 列表   1详细 2预览
      dialogTagList: ["社区", "我的", "收藏"],
      tagSubjectList: [
        { value: "1", label: "语文" },
        { value: "2", label: "数学" },
        { value: "3", label: "英语" },
        { value: "4", label: "科学" },
        { value: "5", label: "物理" },
        { value: "6", label: "化学" },
        { value: "7", label: "生物" },
        { value: "8", label: "历史" },
        { value: "9", label: "地理" },
        { value: "10", label: "政治" }
      ],
      dialogTagList2: [
        { value: 0, name: "通用课堂分析", loading: false },
        { value: 1, name: "学科课堂分析", loading: false },
        { value: 2, name: "扩展分析", loading: false }
      ],
      defaultData: null,
      templateData: [],
      collectData: [],
      analysisDetail: null,
      pageData: {
        nowPage: 1,
        total: 0,
        size: 10
      },
      timer: null
    };
  },
  watch: {
    text() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getData();
      }, 1000);
    }
  },
  methods: {
    open() {
      this.text = "";
      this.tagIndex = 0;
      this.tagSubject = 0;
      this.tagBox = 0;
      this.getData();
      this.getCollectData(false);
      this.getDefaultTemplate();
      this.dialogVisible = true;
    },
    close() {
      // if (this.loading) return;
      this.dialogVisible = false;
      this.text = "";
      this.tagIndex = 0;
      this.tagSubject = 0;
      this.defaultData = null;
      this.tagBox = 0;
    },
    changeTagSubject(subject) {
      if (this.tagSubject == subject) {
        this.tagSubject = 0;
      } else {
        this.tagSubject = subject;
      }
      this.getData();
    },
    changeTagIndex(index) {
      this.tagIndex = index;
      this.tagSubject = 0;
      this.tagBox = 0;
      this.text = "";
      this.getData();
    },
    getMyselfData() {
      this.loading = true;
      this.templateData = [];
      let params = {
        uid: this.userId,
        txt: this.text,
        sub: this.tagSubject,
        type1: 1
      };
      this.ajax
        .get(this.$store.state.api + "selectClassroomTemplate", params)
        .then(res => {
          let _data = res.data[0];
          this.templateData = _data;
        })
        .catch(e => {
          console.log(e);
          this.$message.error("获取数据失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCollectData(flag = true) {
      this.loading = true;
      if (flag) {
        this.templateData = [];
      }
      let params = {
        uid: this.userId,
        txt: this.text,
        sub: this.tagSubject,
        type1: 2
      };
      this.ajax
        .get(this.$store.state.api + "selectClassroomTemplate", params)
        .then(res => {
          let _data = res.data[0];
          if (flag) {
            this.templateData = _data;
          }
          this.collectData = _data;
        })
        .catch(e => {
          console.log(e);
          this.$message.error("获取数据失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPublicData() {
      this.loading = true;
      this.templateData = [];
      let params = {
        uid: this.userId,
        txt: this.text,
        sub: this.tagSubject,
        type1: 0
      };
      this.ajax
        .get(this.$store.state.api + "selectClassroomTemplate", params)
        .then(res => {
          let _data = res.data[0];
          this.templateData = _data;
        })
        .catch(e => {
          console.log(e);
          this.$message.error("获取数据失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getData() {
      if (this.tagIndex == 0) {
        this.getPublicData();
      } else if (this.tagIndex == 1) {
        this.getMyselfData();
      } else if (this.tagIndex == 2) {
        this.getCollectData();
      }
    },
    // 使用
    useAnalysis(item) {
      this.$confirm("确定使用该模板来创建新的课堂吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          let params = {
            uid: this.userId,
            cid: item.id,
            st: 1
          };
          this.ajax
            .get(
              this.$store.state.api + "selectClassroomTemplateDetail",
              params
            )
            .then(res => {
              let _data = res.data[0][0];
              if (_data) {
                this.loading = true;
                _data.tips = JSON.parse(_data.tips);
                this.$emit("useTemplate", _data.tips);
              } else {
                this.loading = false;
                this.$message.error("获取模板详细为空");
              }
            })
            .catch(e => {
              console.log(e);
              this.loading = false;
              this.$message.error("获取模板详细失败");
            })
            .finally(_ => {
              // this.loading = false;
            });
        })
        .catch(() => {
          console.log("取消使用");
        });
    },
    // 保存模板
    saveTemplate(item) {
      this.loading = true;
      let params = [
        {
          uid: this.userId,
          cid: item.id,
          title: item.name,
          jsonData: JSON.stringify(item.tips)
        }
      ];
      this.ajax
        .post(this.$store.state.api + "updateClassroomTemplateData", params)
        .then(res => {
          this.$message.success("保存成功");
          this.back();
          // this.getData();
        })
        .catch(e => {
          console.log(e);
          this.$message.error("保存失败");
        })
        .finally(_ => {
          this.loading = false;
        });
    },
    //预览
    previewAnalysis(item) {
      // this.tagBox = 1;
      this.loading = true;
      let params = {
        uid: this.userId,
        cid: item.id,
        st: 0
      };
      this.ajax
        .get(this.$store.state.api + "selectClassroomTemplateDetail", params)
        .then(res => {
          let _data = res.data[0][0];
          if (_data) {
            _data.tips = JSON.parse(_data.tips);
            _data.tips.sort((a,b)=>a.tIndex - b.tIndex);
            _data.tips.sort((a,b)=>a.Type - b.Type);
            this.analysisDetail = _data;
						let tagList = this.analysisDetail.tips.find(i=>i.isOtherData);
						if(tagList){
							this.dialogTagList2 = tagList.dialogTagList
						}
            this.tagBox = 2;
          } else {
            this.$message.error("获取模板详细为空");
          }
        })
        .catch(e => {
          console.log(e);
          this.$message.error("获取模板详细失败");
        })
        .finally(_ => {
          this.loading = false;
        });
    },
    // 编辑
    editAnalysis(item) {
      // this.tagBox = 2;
      this.loading = true;
      let params = {
        uid: this.userId,
        cid: item.id,
        st: 0
      };
      this.ajax
        .get(this.$store.state.api + "selectClassroomTemplateDetail", params)
        .then(res => {
          let _data = res.data[0][0];
          if (_data) {
            _data.tips = JSON.parse(_data.tips);
            this.analysisDetail = _data;
						let tagList = this.analysisDetail.tips.find(i=>i.isOtherData);
						if(tagList){
							this.dialogTagList2 = tagList.dialogTagList
						}
            this.tagBox = 1;
          } else {
            this.$message.error("获取模板详细为空");
          }
        })
        .catch(e => {
          console.log(e);
          this.$message.error("获取模板详细失败");
        })
        .finally(_ => {
          this.loading = false;
        });
    },
    collect(item) {
      let filter = this.collectData.filter(i => i.id == item.id);
      if (filter.length > 0) {
        let params = [
          {
            uid: this.userId,
            cid: filter[0].id2,
            type: 1
          }
        ];
        this.loading = true;
        this.ajax
          .post(
            this.$store.state.api + "updateClassroomTemplateCollect",
            params
          )
          .then(res => {
            console.log(res);
            this.$message.success("取消收藏成功");
          })
          .catch(e => {
            console.log(e);
            this.$message.error("取消收藏失败");
          })
          .finally(_ => {
            this.loading = false;
            if (this.tagIndex == 2) {
              this.getCollectData();
            } else {
              this.getCollectData(false);
            }
          });
      } else {
        let params = [
          {
            uid: this.userId,
            cid: item.id,
            type: 0
          }
        ];
        this.loading = true;
        this.ajax
          .post(
            this.$store.state.api + "updateClassroomTemplateCollect",
            params
          )
          .then(res => {
            console.log(res);
            this.$message.success("收藏成功");
          })
          .catch(e => {
            console.log(e);
            this.$message.error("收藏失败");
          })
          .finally(_ => {
            this.loading = false;
            if (this.tagIndex == 2) {
              this.getCollectData();
            } else {
              this.getCollectData(false);
            }
          });
      }
    },
    // 删除某条
    delAnalysisItem(type, index) {
      let _data = JSON.parse(JSON.stringify(this.analysisDetail.tips));
      let _fData = _data.filter(i => i.Type == type);
      let _dData = _fData[index];
      let _dIndex = _data.findIndex(
        i => JSON.stringify(i) == JSON.stringify(_dData)
      );
      _data.splice(_dIndex, 1);
      this.analysisDetail.tips = JSON.parse(JSON.stringify(_data));
      // this.$message.success("删除成功");
    },
    // 添加弹窗
    addAnalysisItem(type) {
      this.$refs.addNewAnalysisDialogRef.open(type);
    },
    //添加某条
    addNewAnalysisItem(name, id,type) {
      let _data =
        this.dataList.find(i => i.id == id) ||
        this.dataList.find(i => i.name == name);
      this.analysisDetail.tips.push({
        id: "",
        jsonData: {
          name: _data.name,
          anotherName: _data.name,
          result: _data.brief,
          fileList: [],
          dataFileList: [],
          wordNum: "",
					mId:id,
          wordCountNum: "",
          fileList2: [],
          content: ""
        },
        Type: parseInt(type),
        tIndex: this.analysisDetail.tips.filter(i => i.Type == type)
          .length,
        tId: "",
        createtime: "",
        like_num: 0,
        like_data: null,
        userid: "",
        isdel: 0
      });
      this.$message.success("添加成功");
      this.$refs.addNewAnalysisDialogRef.close();
    },
    //返回
    back() {
      this.tagBox = 0;
      this.analysisDetail = null;
    },
    getDefaultTemplate() {
      let params = {
        uid: this.userId
      };
      this.ajax
        .get(this.$store.state.api + "selectClassroomDefault", params)
        .then(res => {
          let _data = res.data[0][0];
          this.defaultData = _data;
        })
        .catch(e => {
          this.$message.error("获取默认模板失败");
          console.log(e);
        });
    },
    //设置默认
    setDefault(_data) {
      if (this.defaultData.id == _data.id) return;
      this.$confirm("确定设置该模板为默认模板?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = [
            {
              uid: this.userId,
              tid: _data.id
            }
          ];
          this.ajax
            .post(this.$store.state.api + "updateClassroomDefault", params)
            .then(res => {
              // console.log("👇设置默认模板")
              if (res.data == 1) {
                this.$message.success("设置默认模板成功");
              } else {
                this.$message.error("设置默认模板失败");
              }
              this.getDefaultTemplate();
            })
            .catch(e => {
              this.$message.error("设置默认模板失败");
              console.log(e);
              this.getDefaultTemplate();
            });
        })
        .catch(e => {
          console.log(e);
        });
      // this.$message.info("设置默认");
    }
  }
};
</script>

<style scoped>
.analysisTemplateDialog >>> .el-dialog {
  min-width: 1200px;

  height: 700px;
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 8px;
  background-color: #fff;
  /* top: 0px; */
  /* margin: 0 auto; */
  overflow: hidden;
}
.analysisTemplateDialog >>> .el-dialog__body {
  height: 100%;
  min-width: 1200px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-bottom: 50px;
  padding-top: 10px;
}
.analysisTemplateDialog >>> .el-dialog__header {
  display: none;
}
.itemTit {
  width: 136px;
  height: 32px;
  padding: 5px 8px 5px 8px;
  gap: 8px;
  opacity: 0px;
  margin: 20px 0;
  margin-bottom: 10px;
  border-bottom: 1px #ccc solid;
}

.a-d-b-subject {
  margin: 20px 0 20px 0;
}

.a_d_b_s_btn {
  /* box-sizing: border-box; */
  padding: 5px 10px;
  border-radius: 4px;
  border: solid 1px #3681fc;
  color: #3681fc;
  background-color: white;
  margin-right: 10px;
  cursor: pointer;
  transition: 0.3s;
}

.a_d_b_s_ActiveBtn {
  background-color: #3681fc;
  color: white;
}

.a-d-b-i-t-btn:hover {
  background-color: rgba(54, 129, 252, 1);
  color: #fff;
}

.a-d-top {
  /* background: #adadad; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border-radius: 8px 8px 0 0;
  user-select: none;
  border-bottom: 1px #ccc solid;
}
.a-d-top >>> .el-input__inner {
  width: 320px;
  height: 32px;
}
.a-d-top >>> .el-input__icon {
  line-height: 32px;
}
.a-d-topTit {
  width: 171px;
  height: 32px;
  display: flex;
  align-items: center;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  line-height: 22px;
  justify-content: center;
  /* text-align: left; */
}
.a-d-t-left {
  width: 200px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-left: 5px;
}

.a-d-t-l-item {
  /* width: auto;
	height: 90%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 10px;
	border-radius: 10px;
	background-color: #d4d9da;
	margin-right: 3px;
	cursor: pointer; */
  cursor: pointer;
  width: 136px;
  height: 32px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  margin-top: 20px;
  /* margin-bottom: 20px; */
}

.a-d-t-l-item:hover {
  background-color: white;
}

.a-d-t-l-item > svg {
  margin-right: 10px;
}

.a-d-t-right {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black !important;
}

.a-d-t-right > span {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* align-items: center; */
  font-size: 22px;
  color: #fff;
  /* background-color: #adadad; */
  cursor: pointer;
  /* background-color: #e6e6e6; */
  color: #adadad;
}

.a-d-box {
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  overflow: auto;
  box-sizing: border-box;
  padding: 15px;
  padding-bottom: 50px;
}

.a-d-b-item {
  width: 22%;
  height: 200px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  padding: 15px;
  float: left;
  box-sizing: border-box;
  margin-bottom: 10px;
  margin-right: 20px;
  transform: 0.3s;
  box-shadow: 0 16px 24px 2px #f0f2f5;
  /* position: relative; */
}

.a-d-b-item:hover {
  box-shadow: 0 16px 24px 2px #0000001c;
}

.a-d-b-i-bottomPer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #00000066;
}

.a-d-b-i-bottomBtn {
  display: none;
}

.a-d-b-item:hover .a-d-b-i-bottomBtn {
  display: block !important;
}
.a-d-b-item:hover .a-d-b-i-bottomPer {
  display: none !important;
}
.a-d-b-i-top {
  width: 100%;
  /* height: 50%; */
  height: 20px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.a-d-b-i-top > img {
  width: 35px;
  height: 35px;
}
/* .a-d-b-i-top>div{ */
/* width: auto;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: 10px; */
/* } */

.a-d-b-i-t-title {
  width: 100%;
  height: 35px;
  display: block;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  line-height: 35px;
  /* display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	overflow: hidden; */
}

.a-d-b-i-bottom {
  width: 100%;
  flex: 1;
  overflow: hidden;
  /* max-height: 186px; */
  font-size: 14px;
  -webkit-line-clamp: 5;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.a-d-b-i-t-btn {
  font-size: 14px;
  box-sizing: border-box;
  padding: 8px 25px;
  border: 1px solid rgba(54, 129, 252, 1);
  border-radius: 5px;
  color: rgba(54, 129, 252, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.a-d-b-i-t-btn1 {
  font-size: 14px;
  width: 98%;
  box-sizing: border-box;
  padding: 8px 25px;
  border: 1px solid rgba(54, 129, 252, 1);
  border-radius: 5px;
  background-color: rgba(54, 129, 252, 1);
  display: flex;
  color: #fff;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.a_d_b_i_t_collect {
  cursor: pointer;
}

.btnBox {
  width: 100%;
  display: flex;
  height: auto;
  /* padding: 10px; */
  justify-content: space-between;
}

.btnBox > div {
  flex: 1;
  height: auto;
  box-sizing: padding;
  padding: 7px 0;
  margin: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s;
}

.analysisDetail {
  width: 100%;
  height: 100%;
}

.ad_header {
  width: 100%;
  height: 100px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 12px;
}

.ad_h_top {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ad_h_t_left {
  display: flex;
  flex: 1;
  align-items: center;
}

.ad_h_t_back {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 10px;
  border-radius: 4px;
  background-color: #f0f2f5;
  cursor: pointer;
}

.ad_h_t_back > img {
  width: 18px;
  height: 18px;
  margin-right: 2px;
  transform: rotate(-180deg);
}

.ad_h_t_l_title {
  font-size: 20px;
  font-weight: bold;
  margin-left: 10px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 500px;
}

.ad_h_t_l_collect {
  margin-left: 10px;
  cursor: pointer;
}

.ad_h_t_l_collect > img {
  width: 20px;
  height: 20px;
}

.ad_h_bottom {
  display: flex;
  align-items: center;
  color: #00000066;
  font-size: 16px;
}

.ad_h_b_shu {
  width: 1px;
  height: 10px;
  background-color: #999999;
  margin: 2px 8px 0 8px;
}

.ad_bottom {
  width: 100%;
  margin-top: 2px;
  height: calc(100% - 2px - 50px);
  background-color: #fff;
  overflow: auto;
  padding: 12px;
  box-sizing: border-box;
}

.bb_preview:hover {
  background-color: #e0eafb;
}

.bb_edit:hover {
  background-color: #e4e6e9 !important;
}

.bb_use:hover {
  background-color: #3171da !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/analysisTemplateDialog.vue